// export const BASE_API_URL = 'https://mirta-files-api.beetronix.com';
export const BASE_API_URL = 'https://acacia-api.mirta.net';
// export const BASE_API_URL = 'https://localhost:44354';
export const VERSION = 'v2.15.3';